module.exports = __webpack_public_path__ + "img/button_export.67d10a16.svg";